const _moduleExport = {
    UNKNOWN: "unknown",
    NO_FEEDBACK_ERROR: "no_feedback_error",
    NO_PERMISSION_ERROR: "no_permission_error",
    NO_SEARCH_FEEDBACK_ERROR: "no_search_feedback_error"
};
export { _moduleExport as FEEDBACK_ERRORS };
